<template>
  <div class="table-wrapper-scroll-y">
    <table
      class="table table-striped jambo_table bulk_action table_style table-bordered"
      v-loading="vx_isLandmarkTableLoading"
    >
      <thead>
        <tr class="headings">
          <th class="column-title word_center">排序號</th>
          <th class="column-title word_center">地標名</th>
          <th class="column-title word_center">地點</th>
          <th class="column-title word_center">備註</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="vx_landmarkList.length > 0">
          <tr
            class="pointer fontSize16 point text_hailing dropdown"
            v-for="(landmark, index) in vx_landmarkList"
            :key="index"
            @click="setLandmarkInfo(landmark)"
          >
            <td class="word_center">{{ index + 1 }}</td>
            <td class="word_center">{{ landmark.name }}</td>
            <td class="word_center">{{ landmark.address }}</td>
            <td class="word_center">{{ landmark.note }}</td>
          </tr>
        </template>
        <tr v-else>
          <td class="word_center" colspan="4">查無資料</td>
        </tr>
      </tbody>
    </table>
    <!--頁籤-->
    <el-row>
      <el-col :offset="10">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="onPageChange"
          :current-page="
            vx_paging && vx_paging.currentPage ? vx_paging.currentPage : 1
          "
          :page-count="
            vx_paging && vx_paging.totalPages ? vx_paging.totalPages : 1
          "
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions('landmark', {
      vx_fetchLandmarkList: 'fetchLandmarkList',
    }),
    setLandmarkInfo(m) {
      this.$emit('setLandmarkInfoFromList', {
        landmarkID: m.landmarkID,
        name: m.name,
        address: m.address,
        note: m.note,
        latGps: m.addressGPS.coordinates[1],
        lngGps: m.addressGPS.coordinates[0],
        gps: [m.addressGPS.coordinates[1], m.addressGPS.coordinates[0]],
        isOldOne: true,
        serviceName: m.serviceName,
        updatedAt: m.updatedAt,
      })
    },
    onPageChange(page) {
      this.vx_fetchLandmarkList({ currentPage: page })
    },
  },
  computed: {
    ...mapState('landmark', {
      vx_landmarkList: 'landmarkList',
      vx_isLandmarkTableLoading: 'isLandmarkTableLoading',
      vx_paging: 'paging',
    }),
  },
}
</script>

<style scoped>
.table_style {
  overflow: auto;
  height: 200px;
}
.table-wrapper-scroll-y {
  display: block;
  max-height: 600px;
  overflow-y: auto;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

table tr:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/landmark/LandmarkList.vue